import { render, staticRenderFns } from "./SelectDocumentType.vue?vue&type=template&id=070eb556&scoped=true&"
import script from "./SelectDocumentType.vue?vue&type=script&lang=ts&"
export * from "./SelectDocumentType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDocumentType.vue?vue&type=style&index=0&id=070eb556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070eb556",
  null
  
)

export default component.exports